module.exports = __webpack_public_path__ + "static/r7-6040f66f16613a34c9049ed553ad8dad.jpg";